<script lang="ts" setup>
defineProps<{
  /** Loading message */
  message?: string
  /** Spinner size */
  size?: number
  /** Spinner color */
  color?: string
}>()
</script>

<template>
  <section class="dashboard-loading-state">
    <v-progress-circular
      indeterminate
      :size="size ?? 48"
      :width="3"
      :color="color ?? 'primary'"
    />
    <p v-if="message" class="loading-message">{{ message }}</p>
    <slot />
  </section>
</template>

<style lang="scss" scoped>
/* Component uses global dashboard-* classes from dashboard-common.css */

.dashboard-loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--dashboard-gap-md);
  padding: 64px 24px;
  min-height: 200px;
}

.loading-message {
  font-size: var(--dashboard-subtitle-size);
  color: rgba(200, 218, 255, 0.6);
  margin: 0;
}

/* Light Theme */
.v-theme--lightTheme {
  .loading-message {
    color: rgba(15, 23, 42, 0.6);
  }
}
</style>
